import { IconButton } from "@mui/material";
import { DataGrid, GridColumns, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { ArrowBackIos as ArrowBackIosIcon } from "@mui/icons-material";
import Layout from "components/Layout";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import PortfolioController, { PortfolioTransaction } from "services/controllers/PortfolioController";
import { Colors } from "models/Colors";

const CustomToolbar = (props: any) => {
	const { goBackFunction } = props
	return (
		<GridToolbarContainer>
			<IconButton onClick={goBackFunction} size="large">
				<ArrowBackIosIcon style={{ color: Colors.primary }} />
			</IconButton>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
			<GridToolbarDensitySelector />
			<GridToolbarExport />
		</GridToolbarContainer>
	);
}
export default function Portfolio(props: { match: { params: { uid: string, month: string } } }) {
	const [portfolioList, setPortfolioList] = useState<PortfolioTransaction[]>([])
	const [loading, setLoading] = useState<boolean>(true)
	const portfolioController = new PortfolioController()
	const history = useHistory()

	const uid: string = props.match.params.uid
	const month: string = props.match.params.month
	useEffect(() => {
		const fetchData = () => {
			getPortfolio.current()
		}
		return fetchData()
	}, [])

	const columns: GridColumns = [
		{ field: "id", headerName: "Timestamp", width: 150 },
		{ field: "transactionId", headerName: "Transaction Id", width: 400 },
		{ field: "amount", headerName: "Amount", width: 150 },
		{ field: "status", headerName: "Status", width: 150 },
		{ field: "type", headerName: "Type", width: 150 },
		{ field: "ip", headerName: "IP", width: 150 },
	]

	const getPortfolio = useRef(() => { })

	getPortfolio.current = async () => {
		portfolioController.getPortfolio(uid, month, (data) => {
			setPortfolioList(data)
			if (loading)
				setLoading(false)
		})
	}

	return (
		<Layout id={2}>
			<div
				style={{
					height: "calc(100vh - 170px)",
					width: "100%"
				}}>
				<DataGrid
					components={{
						Toolbar: CustomToolbar
					}}
					componentsProps={{
						toolbar: {
							goBackFunction: () => {
								history.push("/users/" + uid + "/portfolio")
							},
						}
					}}
					rows={portfolioList}
					columns={columns}
					loading={loading} />
			</div>
		</Layout>
	)
}
